export const WIDTHS = {
  XSMALL: "xsmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  XLARGE: "xlarge",
  "2XLARGE": "2xlarge",
  "3XLARGE": "3xlarge",
} as const;

export const HEIGHTS = {
  XSMALL: "xsmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  XLARGE: "xlarge",
} as const;

export const RADIUSES = {
  SMALL: "small",
  MEDIUM: "medium",
} as const;
